var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sidebar"},[(_vm.getCurrentSlug && !_vm.getSkuParam)?_c('side-category-panel',{attrs:{"is-categories-loaded":_vm.isCategoriesLoaded,"categories":_vm.tree}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }